

handleMegaMenuSize = () => {
  let nav = document.querySelector('.site-navigation');
  let navWidth = nav.offsetWidth;
  let dropdownItems = document.querySelectorAll('.site-nav__dropdown-container');

  dropdownItems.forEach(el => {
    el.style.width = navWidth + 'px';
  });
}

handleMegaMenuSize();

window.onresize = handleMegaMenuSize;
